import styled from 'styled-components'

import { TanstackButtonLink } from '@/components/menu-button'

export const SubNavLinkContainer = styled.ul`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[5]};
  list-style: none;
  padding: 0;
  margin: 0;
`

export const SubNavLink = styled(TanstackButtonLink).attrs({
  variant: 'flat',
  color: 'tertiary',
})`
  padding-left: 0;
  padding-right: 0;
  border: none;
  border-radius: 0;
  padding-bottom: ${({ theme }) => theme.space[3]};
  &[data-status='active'] {
    box-shadow: inset 0 -4px 0 ${({ theme }) => theme.colors.selection};
  }
`
